<p class="color-redRyder cursor-pointer" (click)="openModal(warningTextModal)">{{value}}</p>

<ng-template #warningTextModal let-modal>
    <div class="mt-3 mb-4">
        <button type="button" class="icon-btn fill-iconDefault modal-close" (click)="modal.close()">
            <svg class="icon-12"><use href="../App_Themes/clearview-default/icons/utility/close.svg#close"></use></svg>
        </button>
        <div class="h-6"><span>Warning for Frequency </span>{{params.data.FrequencyId}}:</div>
        <div class="color-redRyder font-size-12 mt-3 card card-white-bg" style="pointer-events: none;">
            <div class="m-3">{{value}}</div>
        </div>
        <div class="d-flex justify-content-center">
            <button cvLocalizedText langSection="Integration_Logs" langKey="Copy_Text"
                    type="button" 
                    class="btn btn-primary btn-sm mt-3" 
                    [cdkCopyToClipboard]="value">Copy Text</button>
        </div>
    </div>
</ng-template>
